/* eslint-disable @typescript-eslint/no-unused-vars */
import { completeStage, selectStage } from '../redux/slices/stageSlice';
import { useAppDispatch, useAppSelector } from '../redux/hook';
import { DarkButton } from '../components/dark-button';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import React from 'react';
import { selectSession } from '../redux/slices/sessionSlice';
import Signature from '../components/signature';
import useState from 'react-usestateref';
import { useTranslation } from 'react-i18next';

const SignaturePage = ({ setCurrentStep }) => {
	const { t } = useTranslation();
	const [submit, setSubmit, __] = useState(false);
	const dispatch = useAppDispatch();
	const { stages, stage } = useAppSelector(selectStage);
	const { token, reservation, propertyInfo } = useAppSelector(selectSession);

	const specificDataExists = stages.includes('Payment');

	const handleClick = () => {
		setSubmit(true);
		dispatch(
			completeStage({
				token: token,
				stageID: stage?.stepID,
				ReservationID: reservation?.ReservationID,
				type: 'checkin',
				confirmationNo: reservation?.PmsConfirmationNo,
				stages: stages,
				propertyCode: propertyInfo?.propertyCode ?? '', //added new
			})
		);
	};

	return (
		<>
			<div className="d-flex flex-row align-items-center py-3 w-100 bg-white px-3">
				<FontAwesomeIcon
					icon={faChevronLeft}
					className="fs-2"
					style={{ cursor: 'pointer' }}
					onClick={() => setCurrentStep('TnC')}
				/>
			</div>
			<div className="d-flex flex-column gap-4 mt-4 justify-content-around align-items-center w-100">
				<h1
					className="fs-2 fw-semibold text-center p-4"
					style={{ color: '#03355C' }}>
					By signing, I accept the{' '}
					<a href="/terms-and-conditions" style={{ cursor: 'pointer' }}>
						Terms & Privacy Policy
					</a>
				</h1>
				<div className="px-2 w-100">{/* <Signature submit={submit} /> */}</div>
			</div>
			<div
				className="d-flex flex-row justify-content-center button-group pb-4 px-2 border-top gap-4"
				style={{
					backgroundColor: 'white',
					borderColor: 'gray',
				}}>
				{specificDataExists ? (
					<>
						<DarkButton
							text={t('SignaturePageButton1')}
							onClick={handleClick}
						/>
						<DarkButton
							text={t('SignaturePageButton2')}
							onClick={handleClick}
							filled
						/>
					</>
				) : (
					<>
						<DarkButton
							text={t('SignaturePageButton3')}
							onClick={handleClick}
						/>
					</>
				)}
			</div>
		</>
	);
};

export default SignaturePage;
